export const DEFAULT_ACCELERATE_BUTTON = 7;
export const DEFAULT_BRAKE_BUTTON = 6;
export const DEFAULT_STEERING_AXIS = 0;
export const DEFAULT_STEERING_DEADZONE = 0.01;
